/**
 * Zip allowlist for service-area validation. Sourced from
 * cabana-lead-processor/zip_regions.json. Update in tandem when new
 * zips are added (see Cabana-Tasks #169).
 */

export const REGIONS = {
  CA1: [
    '92140','91935','92179','92187','92132','91914','92067','91977','92105',
    '92139','92010','91902','92592','92091','92596','92024','92106','92009',
    '92128','92027','92071','92120','92096','92093','92078','91901','91942',
    '92147','92084','92110','92563','92155','92007','91932','92104','92059',
    '92101','92057','92116','92064','92129','91978','92003','92117','92119',
    '92130','92121','92161','92590','92014','92103','92134','92108','92037',
    '92113','91945','92083','92123','92008','92069','92102','92136','92028',
    '92025','92173','92591','92054','92114','92081','92562','92029','92019',
    '91915','92126','92011','91911','92154','92122','92127','92082','92107',
    '92058','91910','92056','92115','92075','91941','92021','92111','92182',
    '92118','91950','92040','92020','92131','91913','92145','92124','92026',
    '92109',
  ],
  CA2: [
    '90245','90247','90248','90249','90250','90254','90260','90266','90274',
    '90275','90277','90278','90304','90501','90502','90503','90504','90505',
    '90710','90717','90731','90732','90744','90745','90746',
  ],
  CA3: [
    '95677','95628','95610','95821','95650','95621','95746','95747','95841',
    '95838','95678','95608','95630','95652','95661','95662','95660','95673',
    '95843','95842','95765',
  ],
  CA4: [
    '94506','94507','94517','94518','94519','94520','94521','94523','94526',
    '94528','94549','94550','94551','94553','94556','94563','94566','94568',
    '94582','94583','94586','94588','94595','94596','94597','94598',
  ],
};

const ALL_ZIP_TO_REGION = (() => {
  const m = {};
  for (const [region, zips] of Object.entries(REGIONS)) {
    for (const z of zips) m[z] = region;
  }
  return m;
})();

export function checkZip(zip, allowedRegions) {
  const z = String(zip || '').trim();
  if (!z) return { isAllowed: false, foundIn: null };
  const region = ALL_ZIP_TO_REGION[z];
  if (!region) return { isAllowed: false, foundIn: null };
  if (allowedRegions && !allowedRegions.includes(region)) {
    return { isAllowed: false, foundIn: null };
  }
  return { isAllowed: true, foundIn: region };
}
